var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[(!_vm.isIE)?_c('svg-icon',{attrs:{"name":_vm.name}}):_c('img',{attrs:{"src":_vm.imgPath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }